module.exports = __webpack_public_path__ + "img/PRCA1_Treg.11728bfd.png";